import React, { useEffect } from 'react';
import SearchLightGameCard from './SearchLightGameCard';
import SearchLightHeader from './SearchLightHeader';
import Loading from '../loading/Loading';

import './SearchLight.scss';

function SearchLight(props) {
  const {
    auth,
    home,
    getSearchLightGames,
  } = props;
  const searchLight = home && home.searchLight ? home.searchLight : {};
  const games = Array.isArray(searchLight.data) ? searchLight.data : [];
  const loading = searchLight.isLoading === true;
  const error = searchLight && searchLight.errors ? searchLight.errors.message : null;
  const token = auth?.token;
  const currentUserId = auth && auth.user && auth.user.id;

  useEffect(() => {
    getSearchLightGames(token);
  }, [getSearchLightGames, token]);

  return (
    <section className="SearchLight">
      <SearchLightHeader />
      <section className="SearchLight__content">
        <h1 className="SearchLight__title">Developer featured games</h1>

        {loading ? (
          <div className="SearchLight__state SearchLight__state--loading">
            <Loading />
          </div>
        ) : error ? (
          <div className="SearchLight__state SearchLight__state--error">
            <p>{error}</p>
            <button
              type="button"
              className="SearchLight__btn-retry"
              onClick={() => getSearchLightGames(token)}
            >
              Retry
            </button>
          </div>
        ) : games.length === 0 ? (
          <div className="SearchLight__state SearchLight__state--empty">
            <p>No games on SearchLight yet. Check back later.</p>
          </div>
        ) : (
          <div className="SearchLight__games">
            {games.map((game) => (
              <SearchLightGameCard
                key={game.id}
                game={game}
                token={token}
                currentUserId={currentUserId}
                onLikeSuccess={() => getSearchLightGames(token, false)}
              />
            ))}
          </div>
        )}
      </section>
    </section>
  );
}
export default SearchLight;
